import { render, staticRenderFns } from "./OrganizationalPreferencesPane.vue?vue&type=template&id=78640b13&"
import script from "./OrganizationalPreferencesPane.vue?vue&type=script&lang=ts&"
export * from "./OrganizationalPreferencesPane.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('78640b13')) {
      api.createRecord('78640b13', component.options)
    } else {
      api.reload('78640b13', component.options)
    }
    module.hot.accept("./OrganizationalPreferencesPane.vue?vue&type=template&id=78640b13&", function () {
      api.rerender('78640b13', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "landing/src/molecules/organization/profile/OrganizationalPreferencesPane.vue"
export default component.exports